export default "__VITE_ASSET__BBrNuMaU__"